import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import Community from './pages/Community';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Music from './pages/Music';
import Streaks from './pages/Streaks';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Mood from './pages/Mood';
import Devotional from './pages/Devotional';
import Profile from './pages/Profile';
import Breathing from './pages/Breathing';
import Crisis from "./pages/Crisis";
import MoodInsights from './pages/MoodInsights';
import Voice from './pages/Voice';


const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#4ade80' },
    background: { default: '#0f0f1a' },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", sans-serif',
  },
});

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/" />;
};

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={
            <ProtectedRoute><Dashboard /></ProtectedRoute>
          } />
          <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />
  
          <Route path="/profile" element={<Profile />} />
          
          <Route path="/streaks" element={
            <ProtectedRoute><Streaks /></ProtectedRoute>
          } />
          <Route path="/mood" element={
            <ProtectedRoute><Mood /></ProtectedRoute>
          } />
          <Route path="/music" element={<Music />} />
          <Route path="/community" element={<Community />} />
          <Route path="/devotional" element={<Devotional />} 
          />
          <Route path="/breathing" element={<Breathing />} />
          <Route path="/crisis" element={<Crisis />} />
          <Route path="/mood-insights" element={<ProtectedRoute><MoodInsights /></ProtectedRoute>} />
        <Route path="/voice" element={<ProtectedRoute><Voice /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Analytics />
    </ThemeProvider>
  );
}